/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationIngestionData } from '../definitions';
import type FreshdeskPlatform from '../../freshdesk';

export default class FreshdeskConversationIngestion implements ConversationIngestionData {
  private platform: FreshdeskPlatform;

  constructor(platform: FreshdeskPlatform) {
    this.platform = platform;
  }

  get drawerTitle() {
    return this.platform.intl.t(
      'standalone.common.conversation-ingestion.freshdesk-ticket-history',
    );
  }

  get syncHistoryTitle() {
    return this.platform.intl.t(
      'standalone.common.conversation-ingestion.sync-conversation-history.freshdesk.title',
    );
  }

  get syncTicketHistoryLabel() {
    let instanceUrl =
      this.platform.activeConfiguration?.domain ||
      this.platform.intl.t(
        'standalone.common.conversation-ingestion.sync-conversation-history.default-instance-label',
      );
    return this.platform.intl.t(
      'standalone.common.conversation-ingestion.sync-conversation-history.sync-label',
      {
        instanceUrl,
      },
    );
  }

  get disableSyncBody() {
    return this.platform.intl.t('standalone.freshdesk.settings.connect.disable-sync-body');
  }

  get importingEnabledNotificationMessage() {
    return this.platform.intl.t('standalone.freshdesk.settings.connect.conv-importing-enabled');
  }

  get deployCopilotRoute() {
    return 'apps.app.standalone.deploy.freshdesk.copilot';
  }
}
